import _ from 'lodash';
import formatterUtils from './formatter-utils';

const variablesRegex = /\${([^}]+)}/g;
const pipe = '|';

function replaceVariablesInText(text, insightData) {
  return text.replace(variablesRegex, (match, key) => {
    // Check if variable includes formatters like 'billingAmount | round'
    const { variableName, formatters } = key.includes(pipe) ? formatterUtils.parseFormatter(key) : { variableName: key.trim() };
    // Handle and replace piiId with the right piiValue
    const resolvedVariableName = variableName.endsWith('PiiId') ? variableName.replace('PiiId', 'PiiValue') : variableName;
    // Get the value of the variable from the insightData data
    const variableValue = _.get(insightData, resolvedVariableName);
    if (formatters && formatters.length) {
      return formatterUtils.applyFormatters(variableValue, formatters);
    }
    return variableValue;
  });
}

function getVariableNamesFromText(text) {
  const variableNames = Array.from(text.matchAll(variablesRegex), match => match[1]);
  return _.chain(variableNames)
    .compact()
    .map(variable => variable.trim())
    // if we have formatters like 'billingAmount | round' we want to remove the pipe and everything after it
    .map(variable => variable.includes(pipe) ? variable.split(pipe)[0].trim() : variable)
    .value();
}

export default {
  getVariableNamesFromText,
  replaceVariablesInText,
};
